export interface SearchFilters {
  query?: string;
  reference_number?: string;
  related_party?: string;
  subject_location?: string;
  document_type?: string;
  document_year?: number;
  year_from?: number;
  year_to?: number;
  page: number;
  page_size: number;
}

export interface SearchResult {
  id: string;
  reference_number?: string;
  related_party?: string;
  subject_location?: string;
  document_type?: string;
  document_year?: number;
  file_name: string;
  original_file_name?: string;
  blob_url: string;
  score: number;
  highlights?: Record<string, string[]>;
  requires_review?: boolean;
}

export interface FacetValue {
  value: string;
  count: number;
}

export interface SearchFacets {
  reference_number: FacetValue[];
  related_party: FacetValue[];
  subject_location: FacetValue[];
  document_year: FacetValue[];
}

// Rate-limit metadata attached to a successful (HTTP 200) search response.
export interface RateLimitInfo {
  current_count: number;
  remaining_requests: number;
  window_ends_at: string; // ISO-8601 UTC, e.g. "2026-06-30T12:00:00Z"
  max_requests: number;
}

// Payload returned inside the HTTP 429 envelope when the global limit is hit.
export interface RateLimitExceeded {
  maxRequests: number;
  currentCount: number;
  remainingRequests: number;
  windowEndsAt: string; // ISO-8601 UTC
  retryAfterSeconds: number;
}

export interface SearchResponse {
  results: SearchResult[];
  total_count: number;
  page: number;
  page_size: number;
  total_pages: number;
  facets?: SearchFacets;
  rate_limit?: RateLimitInfo;
}

export interface FilterOptions {
  outside_agencies: string[];
  document_types: string[];
}

export interface AdminDocument extends SearchResult {
  upload_date?: string;
  processed_date?: string;
  extraction_confidence?: number;
  reviewed_by?: string;
  reviewed_date?: string;
  document_year?: number;
  pii_detected?: boolean;
  pii_entities?: string[];
  document_type?: string;
}

// Admin-configurable global AI Search rate limit + live usage.
export interface RateLimitConfig {
  max_requests: number;
  current_count: number;
  remaining_requests: number;
  window_ends_at: string; // ISO-8601 UTC
  configured: boolean;
}

export interface SearchResultLimitConfig {
  max_results: number;
  configured: boolean;
}

export interface AdminUpdateRequest {
  reference_number?: string;
  related_party?: string;
  subject_location?: string;
  document_type?: string;
  document_year?: number;
}

export const DOCUMENT_TYPE_OPTIONS: { value: string; label: string }[] = [
  { value: "resolutions", label: "Resolution" },
  { value: "contracts", label: "Contract" },
];

export interface LoginRequest {
  username: string;
  password: string;
}

export interface LoginResponse {
  access_token: string;
  token_type: string;
  expires_in: number;
  user: {
    username: string;
    role: string;
    email?: string;
  };
}
